import { Component, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { KorviuButtonComponent } from '../../../../shared/components/korviu-button/korviu-button.component';

@Component({
  selector: 'app-log-out-confirmation-modal',
  standalone: true,
  imports: [TranslateModule, KorviuButtonComponent],
  templateUrl: './log-out-confirmation-modal.component.html',
  styleUrl: './log-out-confirmation-modal.component.scss'
})
export class LogOutConfirmationModalComponent {
  readonly cancelled = output<void>();
  readonly confirmed = output<void>();
}
